import { render, staticRenderFns } from "./wr_ytc_report.vue?vue&type=template&id=70ebd774&scoped=true"
import script from "./wr_ytc_report.vue?vue&type=script&lang=js"
export * from "./wr_ytc_report.vue?vue&type=script&lang=js"
import style0 from "./wr_ytc_report.vue?vue&type=style&index=0&id=70ebd774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ebd774",
  null
  
)

export default component.exports